import { render, staticRenderFns } from "./CustomerFormDocuments.vue?vue&type=template&id=e1a6f11a&scoped=true"
import script from "./CustomerFormDocuments.vue?vue&type=script&lang=ts"
export * from "./CustomerFormDocuments.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFormDocuments.vue?vue&type=style&index=0&id=e1a6f11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a6f11a",
  null
  
)

export default component.exports